import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DepartamentoService } from 'src/app/service/departamento.service';
import { Departamento } from './departamento';

@Component({
  selector: 'app-departamento-form',
  templateUrl: './departamento-form.component.html',
  styleUrls: ['./departamento-shared.scss'],
})
export class DepartamentoFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;

  constructor(
    private fb: FormBuilder,
    private service: DepartamentoService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarForm(item?: Departamento) {
    this.formulario = this.fb.group({
      id: [item?.id ?? null],
      nome: [item?.nome ?? '', Validators.required],
      descricao: [item?.descricao ?? ''],
      ativo: [item?.ativo ?? true],
    });
  }

  carregar(id: number) {
    this.carregando = true;
    this.service.buscarPorId(id).subscribe(item => {
      this.montarForm(item);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Departamento não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    if (this.formulario.invalid) {
      return;
    }
    this.service.salvar(this.formulario.value).subscribe(() => {
      this.snackBar.open('Departamento salvo com sucesso.', 'OK', { duration: 2500 });
      this.voltarConsulta();
    }, err => this.snackBar.open(err.error?.message ?? 'Erro ao salvar.', 'ERRO', { duration: 3000 }));
  }

  limpar() {
    this.router.navigate(['/departamento/form']);
    this.montarForm();
  }

  voltarConsulta() {
    this.router.navigate(['/departamento/consulta']);
  }
}
